import React, { memo, useEffect, useState } from "react";
import _ from "lodash";
import axios from "axios";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel as UnstyledCarousel } from "react-responsive-carousel";
import {styled} from "@mui/material/styles";

import Quotes from "./Quotes";

const Carousel = styled(UnstyledCarousel)`
	& .carousel {
		padding-bottom: 32px;

		.control-next.control-arrow:hover,
		.control-prev.control-arrow:hover {
			background-color: transparent;
		}

		.control-arrow,
		.carousel.carousel-slider .control-arrow {
			opacity: 1;
		}

		.control-next.control-arrow:before {
			border: solid ${(props) => props.theme.palette.secondary.main};
			border-width: 0 8px 8px 0;
			padding: 14px;
			transform: rotate(-45deg);
			-webkit-transform: rotate(-45deg);
		}

		.control-prev.control-arrow:before {
			border: solid ${(props) => props.theme.palette.secondary.main};
			border-width: 0 8px 8px 0;
			padding: 14px;
			transform: rotate(135deg);
			-webkit-transform: rotate(135deg);
		}
	}

	& .control-dots .dot {
		background: ${(props) => props.theme.palette.secondary.main};
	}

	& .carousel.carousel-slider {
		overflow: inherit;
	}
`;

function QuotesCarousel() {
	const [ quotes, setQuotes ] = useState([]);

	useEffect(() => {
		axios
			.get(process.env.REACT_APP_DIRECTUS_URL + "/items/Appraisal_Quotes?filter[status][_eq]=published")
			.then((response) => {
				setQuotes(_.sortBy(response.data.data, ["sort", "date_updated"]));
			});
	}, []);
	
	return (
		<Carousel showThumbs={false} showStatus={false} infiniteLoop={true}>
			{ (quotes && quotes.length > 0) &&
				_.map(quotes, (quote, key) => <Quotes key={ key } quote={ quote } />)
			}
		</Carousel>
	);
}

export default memo(QuotesCarousel);
